export const recentsCacheName = 'state.recents';
export const RECENTS_SESSION_CACHE_NAME = 'recents.session';
